import React, { Component } from "react";
import { ExpansionPanel, ExpansionPanelDetails } from "@material-ui/core/";
import { Card, CardBody } from "reactstrap";
import Fade from "react-reveal/Fade";
import { Input } from "reactstrap";
import Select from "react-select";
import { Button } from "reactstrap";
import Table from "../../../Components/Table";
import axios from "axios";
import {Services} from "../../Services";
import ListUser from "./listUsers";
import ReportAsing from "./reportAssig";
import Tooltip from "@material-ui/core/Tooltip";
import Errors from "../../../Components/Errors";
// const useStyles = makeStyles(theme => ({
//   fab: {
//     margin: theme.spacing(2),
//   },
//   absolute: {
//     position: 'absolute',
//     bottom: theme.spacing(2),
//     right: theme.spacing(3),
//   },
// }));

class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selecccion: null,
      selectcheck: true,
      modal: false,
      dataDocuments: [],
      dataReport: {},
      AsociadosClient: [],
      flatNext: false,
      reset: false,
      UserList: [],
      newSelected: [],
      mainColumns: [],
      dataSelect: [],
      roles: [],
      CustomerId: "",
      CreateFormData: [],
      CreateForAdd: [],
      Form: this.props.form,
      selected: [],
      data: this.props.customerList,
      datall: this.props.customerList,
      error: {
        open: false,
        message: "",
        type: "admin",
      },
      user: {
        Name: "",
        LastName: "",
        Position: "",
        Email: "",
        Password: "",
        RoleId: "",
        Telephone: "",
      },
      columns: [
        {
          label: "ID",
          key: "CustomerId",
          custom: (value) => (
            <em
              onClick={() =>
                this.setState({ active: !this.state.active }, () => {})
              }
            >
              {" "}
              <label style={{}}>{value.CustomerId}</label>{" "}
            </em>
          ),
        },
        { label: "Customer Name", key: "Name" },
        // { label: 'Customer Code', key: 'CustomerCode' },
        // { label: 'NIT', key: 'NIT' },
        // { label: 'Grupo', key: 'Grupo' },
        { label: "Telephone", key: "Telephone" },
        { label: "Country", key: "Country" },
        { label: "Logo", key: "" },
        // { label: 'Usuarios Asociados', key: 'UsuariosAsociados' },
        {
          label: "addAll",
          key: "addAll",
          custom: (value) => this.custom1(value),
        },
      ],
      columnsAsociados: [
        {
          label: "ID",
          key: "CustomerId",
          custom: (value) => (
            <em
              onClick={() =>
                this.setState({ active: !this.state.active }, () => {})
              }
            >
              {" "}
              <label style={{}}>{value.CustomerId}</label>{" "}
            </em>
          ),
        },
        { label: "Customer Name", key: "Name" },
        // { label: 'Customer Code', key: 'CustomerCode' },
        // { label: 'NIT', key: 'NIT' },
        { label: "Group", key: "Grupo" },
        { label: "Telephone", key: "Telephone" },
        { label: "Country", key: "Country" },
        { label: "Logo", key: "" },
        // { label: 'Usuarios Asociados', key: 'UsuariosAsociados' },
        { label: "", key: "", custom: (value) => this.custom2(value) },
      ],
      errorValidate: false,
    };
  }

  custom1 = (value) => (
    <em
      class="fa-2x mr-2 fas fa-plus-circle"
      onClick={this.addClientGroup(value)}
      style={{ marginTop: "5px", color: "rgb(0, 121, 184)" }}
    ></em>
  );
  custom2 = (value) => (
    <em
      class="fa-2x mr-2 fas fa-minus-circle"
      onClick={this.deleteClient(value)}
      style={{ marginTop: "5px", color: "rgb(0, 121, 184)" }}
    ></em>
  );
  addClientGroup = (index) => (event) => {
    let { newSelected } = this.state;
    let newClietAsociados = newSelected;
    newClietAsociados.push(index);
    let deleteValue = index;
    let itemNew = this.state.data.filter((e) => {
      if (e.CustomerId !== deleteValue.CustomerId) {
        return e;
      }
      return 0;
    });

    this.setState({
      newSelected: newClietAsociados,
      data: itemNew,
    });
  };
  deleteClient = (index) => (event) => {
    let deleteValue = index;
    let itemNew = this.state.newSelected.filter((e) => {
      if (e.CustomerId !== deleteValue.CustomerId) {
        return e;
      }
      return 0;
    });

    let newClietAsociados = this.state.data;

    newClietAsociados.push(index);

    newClietAsociados.sort(function (a, b) {
      return a.CustomerId - b.CustomerId;
    });

    this.setState({
      newSelected: itemNew,
      data: newClietAsociados,
    });
  };
  componentDidMount = () => {
    // console.log("this.props.customerList",this.props.customerList);
    this.getRoles();
    this.getUser();
  };
  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        this.getRoles();
        this.getUser();
      }
    );
  };

  getUser = (save) => {
    axios
      .get(`${Services.GetUser.path}admin/GetUser`, {})
      .then((response) => {
        // console.log("repose, get user",response);

        if (save) {
          this.setState({
            UserList: response.data.data,
            reset: true,
          });
        } else {
          this.setState({
            UserList: response.data.data,
            reset: false,
          });
        }
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getRoles = () => {
    axios
      .get(`${Services.GetRole.path}admin/roles`, {})
      .then((response) => {
        // console.log("repose, roles",response);

        this.setState({ roles: response.data.data }, () => {
          // this.setState({
          //   data: this.props.customerList
          // });
          this.buildFormCreate();
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  validateSaveUser = (e) => (evt) => {
    let validation = [];
    let errors = "";
    let Form = this.props.form.CreateUser;

    if (this.state.passcorrect) {
      Form.map((e) => {
        if (e.required === true) {
          validation.push(e);
        }
        return e;
      });
      validation.forEach((e) => {
        if (this.state.user[e.id] === "") {
          errors += e.label + ", ";
          document.getElementById(e.id).style.color = "red";
        }
      });
      if (errors.length > 0) {
        this.setState(
          {
            submitt: true,
          },
          () => {
            this.buildFormCreate();
          }
        );
        this.setState({
          error: {
            message: "Required fields: " + errors + "",
            open: true,
            type: "error",
          },
        });
      } else {
        this.saveUser();
      }
    } else {
      this.setState({
        error: {
          message: "The password does not comply with the specified format",
          open: true,
          type: "error",
        },
      });
    }
  };

  saveUser = () => {
    let data = {
      data: this.state.user,
      items: this.state.newSelected,
      report: this.state.dataReport,
      documents: this.state.dataDocuments,
    };
    axios
      .post(`${Services.PostUser.path}admin/createUser`, data)
      .then((response) => {
        this.setState(
          {
            newSelected: [],
            user: {
              Name: "",
              LastName: "",
              Position: "",
              Email: "",
              Password: "",
              RoleId: "",
              Telephone: "",
            },
            selecccion: null,
            reset: true,
            data: this.state.datall,
            columns: this.state.columns,
            flatNext: false,
          },
          () => {
            this.getUser(true);
            this.buildFormCreate();
            this.props.onError({
              error: {
                message: "The User has been saved successfully!",
                open: true,
                type: "admin",
              },
            });
          }
        );
      })
      .catch((error) => {
        if (
          error.response.data.message === "Existing Email, Try a Different One"
        ) {
          this.setState({
            error: {
              message: error.response.data.message,
              open: true,
              type: "error",
            },
          });
        }
        // else {
        //   this.setState({
        //     error: {
        //       message: "Dato incorrecto, favor de verificar",
        //       open: true,
        //       type: "error",
        //     },
        //   });
        // }
      });
  };

  PutUser = (dataUserPut) => {
    axios
      .put(`${Services.PutUser.path}admin/updateUser`, dataUserPut)
      .then((response) => {
        this.setState(
          {
            error: {
              message: "The User has been saved successfully!",
              open: true,
              type: "admin",
            },
            modal: false,
            errorValidate: false,
          },
          () => {
            this.getUser();
            this.buildFormCreate();
          }
        );
      })
      .catch((error) => {
        if (
          error.response.data.message === "Existing Email, Try a Different One"
        ) {
          this.setState({
            error: {
              message: error.response.data.message,
              open: true,
              type: "error",
            },
          });
        }
        //  else {
        //   this.setState({
        //     error: {
        //       message: "Dato incorrecto, favor de verificar",
        //       open: true,
        //       type: "error",
        //     },
        //   });
        // }
        this.setState({
          errorValidate: true,
        });
      });
  };

  ValidateEmail = () => {
    let data = {
      data: this.state.user,
    };
    axios
      .post(`${Services.validateEmail.path}admin/validateEmailUser`, data)
      .then((response) => {
        this.setState({ flatNext: true });
      })
      .catch((error) => {
        console.warn("..--->>", error.response.data.message);
        if (
          error.response.data.message === "Existing Email, Try a Different One"
        ) {
          this.setState({
            error: {
              message: error.response.data.message,
              open: true,
              type: "error",
            },
          });
        }
      });
  };

  handleChange = (name) => (event) => {
    if (name === "Password") {
      let value = event.target.value;

      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/
      );
      if (emailRegex.test(value)) {
        this.setState({
          passcorrect: true,
        });
        document
          .getElementById("pass_diferentes")
          .setAttribute("hidden", "hidden");
      } else {
        this.setState({
          passcorrect: false,
        });
        document.getElementById("pass_diferentes").removeAttribute("hidden");
      }
    }
    document.getElementById(name).style.color = "black";
    let { user } = this.state;
    user[name] = event.target.value;
    this.setState(
      {
        user,
      },
      () => {
        this.buildFormCreate();
      }
    );
  };

  handleChangeSelect = (selected) => (event) => {
    document.getElementById(selected).style.color = "black";
    if (event && event.value) {
      let { user } = this.state;
      user[selected] = event.value;
      this.setState({ user, selecccion: event }, () => {
        this.buildFormCreate();
      });
    } else {
      let { user } = this.state;
      user[selected] = "";
      this.setState({ user, selecccion: null }, () => {
        this.buildFormCreate();
      });
    }
  };

  buildFormCreate = () => {
    const { Form, user, roles } = this.state;

    let CreateFormData = Form.CreateUser.map((e, i) => {
      if (e.type === "Input")
        return (
          <div className={e.class} key={e.id}>
            <Fade left opposite>
              {" "}
              <span id={e.id} style={e.style}>
                <label>
                  {e.label} {e.required === true ? <span>*</span> : ""}
                </label>
              </span>
            </Fade>
            <Input
              // id={e.id}
              required
              type={e.datatype}
              placeholder={e.placeHolder}
              name={e.id}
              value={user[e.id]}
              maxlength={e.maxlength}
              minlength={e.minlength}
              onChange={this.handleChange(e.id)}
              max={e.max}
            />
            <Fade left opposite>
              <label style={e.style}>{e.error}</label>
            </Fade>
            {e.id === "Password" ? (
              <Fade left opposite>
                <div
                  style={{
                    padding: "",
                    marginTop: "",
                    color: "#BA2B30",
                    fontSize: "12px",
                  }}
                  className="_alert"
                  id="pass_diferentes"
                  hidden
                >
                  <label>
                    <b>The password must be composed of</b>
                  </label>
                  <br></br>
                  <label>* Minimum 8 characters and maximum 15</label>
                  <label>* At least one capital letter</label>
                  <label>* A special character (*! $% &?).</label>
                </div>
              </Fade>
            ) : (
              <></>
            )}
          </div>
        );
      else if (e.type === "Select")
        return (
          <div className={e.class} key={e.id}>
            <Fade left opposite>
              <span id={e.id} style={e.style}>
                {" "}
                <label>
                  {e.label} {e.required === true ? <span>*</span> : ""}{" "}
                </label>
              </span>
            </Fade>
            <Select
              // id={e.id}
              isClearable={true}
              required
              type={e.datatype}
              name={e.name}
              value={this.state.selecccion}
              placeholder="Select..."
              onChange={this.handleChangeSelect(e.id)}
              options={roles}
            />
            <Fade left opposite>
              <label style={e.style}>{e.error}</label>
            </Fade>
          </div>
        );
      return e;
    });
    this.setState({
      CreateFormData,
    });
  };
  recieve = (array) => {
    this.setState({
      newSelected: array,
    });
  };

  dataReport = (data, edit) => {
    let dataReport = { data: data, userId: this.props._user };
    this.setState({
      dataReport,
    });
  };

  newdata = (data) => {
    // if (data){
    //   this.findData(data, true);
    // }
    // else{
    //   this.findData(this.state.dataOriginal, true);
    // }
  };

  dataDocuments = (dataPo, dataship, edit) => {
    let array = [];
    dataPo.map((e) => {
      if (e.check) {
        let data = {
          DocCategoryId: e.DocCategoryId,
          ModuleId: e.ModuleId,
          UserId: this.props._user,
        };
        array.push(data);
      }
      return e;
    });
    dataship.map((e) => {
      if (e.check) {
        let data = {
          DocCategoryId: e.DocCategoryId,
          ModuleId: e.ModuleId,
          UserId: this.props._user,
        };
        array.push(data);
      }
      return e;
    });
    this.setState({
      dataDocuments: array,
    });
  };

  recieveProps = (open) =>
    this.setState({ error: { open: open, type: this.state.error.type } });

  render() {
    return (
      <>
        <Errors
          open={this.state.error.open}
          type={this.state.error.type}
          message={this.state.error.message}
          setProps={this.recieveProps}
        ></Errors>
        <Card>
          <CardBody className="myCard">
            <ExpansionPanel elevation={0} defaultExpanded>
              <div className="col-md-12">
                <strong style={{ marginLeft: "-12px" }}>
                  User Information
                </strong>
                <br></br>
              </div>
              <ExpansionPanelDetails>
                <div className="row" style={{ width: "100%" }}>
                  <div className="col-md-12">
                    <div className="row">{this.state.CreateFormData}</div>
                  </div>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            {this.state.flatNext ? (
              <div>
                <ReportAsing
                  dataDocuments={this.dataDocuments}
                  dataReport={this.dataReport}
                  columns={this.state.columns}
                  newSelected={this.state.newSelected}
                ></ReportAsing>
              </div>
            ) : (
              <>
                <div className="col-md-12">
                  <strong style={{ marginLeft: "-12px", color: "black" }}>
                    Select Customer
                  </strong>
                  <br></br>
                  <br></br>
                </div>
                <Table
                  renderData={this.newdata}
                  columns={this.state.columns}
                  data={this.state.data}
                  mainColumns={this.state.mainColumns}
                  bordered={true}
                  itemsByPage={10}
                  options={{
                    // pagination: true,
                    large: true,
                    selectGroup: true,
                    search: false,
                    pagination: true,
                    downloads: {
                      pdf: false,
                      xlsx: false,
                    },
                    // selectItems: true,
                    reset: this.state.reset,
                  }}
                  // onSelect={this.recieve}
                />
                <div style={{ height: "60px" }}></div>
                <div className="col-md-12">
                  <strong style={{ marginLeft: "-12px", color: "black" }}>
                    Associated Customers
                  </strong>
                  <br></br>
                  <br></br>
                </div>
                <Table
                  columns={this.state.columnsAsociados}
                  data={this.state.newSelected}
                  bordered={true}
                  itemsByPage={10}
                  options={{
                    // pagination: true,
                    large: true,
                    selectGroup: true,
                    search: false,
                    pagination: true,
                    downloads: {
                      pdf: false,
                      xlsx: false,
                    },
                    // selectItems: true,
                    reset: this.state.reset,
                  }}
                  // onSelect={this.recieve}
                />
              </>
            )}
            <br></br>
            <br></br>
            <div className="row">
              <div className="col-md-6 col-lg-4 col-sm-12"></div>
              <div
                style={{ textAlign: "center" }}
                className="col-md-2 col-lg-2 col-sm-4"
              >
                <Button
                  variant="contained"
                  color="danger"
                  className="button"
                  onClick={() => {
                    this.setState(
                      {
                        reset: true,
                        flatNext: false,
                        user: {
                          Name: "",
                          LastName: "",
                          Position: "",
                          Email: "",
                          Password: "",
                          RoleId: "",
                          Telephone: "",
                        },
                        newSelected: [],
                      },
                      () => {
                        let Form = this.props.form.CreateUser;
                        Form.map((e) => {
                          document.getElementById(e.id).style.color = "black";
                          return e;
                        });
                        this.buildFormCreate();
                        this.setState({ reset: false });
                      }
                    );
                  }}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-md-2 col-lg-1 col-sm-4">
                {this.state.flatNext ? (
                  <Button
                    variant="contained"
                    disabled={this.state.newSelected.length <= 0 ? true : false}
                    color="primary"
                    className="button"
                    onClick={this.validateSaveUser()}
                  >
                    Save
                  </Button>
                ) : (
                  <>
                    {" "}
                    <Tooltip
                      open={false}
                      interactive={true}
                      title="selecting a customer is required"
                      //  placement="placement"
                    >
                      <span>
                        <Button
                          variant="contained"
                          disabled={
                            this.state.newSelected.length <= 0 ? true : false
                          }
                          color="primary"
                          className="button"
                          // onClick={() => {
                          //   this.setState({ flatNext: true });
                          // }}
                          onClick={() => {
                            this.ValidateEmail();
                          }}
                        >
                          Next
                        </Button>
                      </span>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
        <ListUser
          errorValidate={this.state.errorValidate}
          userId={this.props._user}
          modal={this.state.modal}
          dataDocuments={this.dataDocuments}
          dataReport={this.dataReport}
          saveUser={this.PutUser}
          onError={this.onError}
          deleteUser={this.props.deleteUser}
          customerList={this.props.customerList}
          Roles={this.state.roles}
          Form={this.state.Form}
          UserList={this.state.UserList}
        ></ListUser>
      </>
    );
  }
}

export default createUsers;
